import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import EcoEmail from 'eco-design/elements/eco-email';
import styles from './index.module.scss';
import { lang } from './lang';
import getLocal from '@/app/utils/getLocal';

const Banner = () => {
    const { t } = useLang('Delta3MaxSeriesPreheat.banner');
    const { locale } = getLocal();
    const langText = lang[locale];
    const fields = [
        // 站点字段
        {
            id: '12713',
            type: 'multiple',
            value: [4],
            overwrite: false,
        },
    ];

    const bannerProps: EcoBannerProps = {
        layout: 'top-center',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1756374633462/KV%20(3)%20(2).jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1756374633462/KV%20(3)%20(2).jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1756379015764/d3m-bg-m.jpg',
        childrenA: (
            <EcoEmail
                contactListId={['1935415334']}
                source="WEB_NEW_PRODUCT_SUB"
                fields={fields}
                termsHtml={langText.term}
                tipsObj={{
                    btnText: t('send_btn'),
                    placeholder: t('email_input'),
                    successTips: t('success_tips'),
                    tipsFailed: t('error_tips'),
                    tipsTypeError: t('error_tips'),
                }}
                subscribeData={{
                    sector_name: t('title'),
                    entry_position: '1',
                }}
            ></EcoEmail>
        ),
        title: t('title'),
        subTitle: t('subtitle'),
        desc: t('desc'),
        className: styles.Banner,
    };

    return <EcoBanner {...bannerProps}></EcoBanner>;
};

export default Banner;
